import stakeholders from '@/assets/data/about/stakeholders';

export default {
  namespaced: true,
  state: () => ({
    list: stakeholders
  }),
  getters: {
    list: state => {
      return state.list;
    }
  },
  actions: {},
  mutations: {}
};
